import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'obfuscateOtpEmail',
})
export class ObfuscateOtpEmailPipe implements PipeTransform {
  transform(value: string, characters: string) {
    const stringSplit = value.split('@');
    const stringFirst: any = stringSplit[0];
    const newstr = characters === 'ALL' ? this.convertMailAll(stringFirst) : this.convertMailParcial(stringFirst);
    const email = `${newstr}@${stringSplit[1]}`;
    return email;
  }

  convertMailAll(stringFirst: string) {
    return stringFirst.split('').reduce((acc) => {
      acc += '*';
      return acc;
    }, '');
  }

  convertMailParcial(stringFirst: string) {
    return stringFirst.split('').reduce((acc, curr, i) => {
      acc += i < 2 ? curr : '*';
      return acc;
    }, '');
  }
}
